var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "main-view-stage-2"
  }, [_c('client-needs-pop-up', {
    attrs: {
      "show": _vm.showClientNeeds
    }
  }), _c('document-cloud-handler', {
    attrs: {
      "cloud-meta": _vm.getCloudMeta(),
      "rules": ['single'],
      "class-cst": 'cloud-button add-obhliadka white--text no-decoration',
      "icon-button": ""
    }
  }), _vm._l(_vm.mortgageEvents, function (event, index) {
    return _c('client-sign-event-holder', {
      key: index,
      attrs: {
        "event": event
      }
    });
  }), _c('mortgage-applications-sign-wrapper', {
    attrs: {
      "applications": _vm.mortgage.applications
    }
  })], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }